<template>
  <div
    class="wf-relative"
    :class="! previewMode ? 'wf-border wf-border-transparent hover:wf-border-blue-300 wf-py-4 wf-pb-2 wf-px-1' : ''"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <EditorOptions
      parent="component"
      v-show="hover && ! previewMode"
      :options="menuOptions"
      :parentModule="parentModule"
    />
      <div
        :class="elementClasses(classes('classes'))"
        :style="elementStyles(styles('styles'))"
        style="width:100%; height:100px"
        ref="google-maps"
      ></div>
      <button
        v-show="! previewMode"
        ref="control-marker"
        @click="addMarker"
        title='Click to add a new marker'
        class="wf-bg-blue-300 hover:wf-bg-blue-500 wf-text-white wf-p-1 wf-text-sm wf-rounded-b wf-cursor-pointer"
      ><i class="fas fa-map-marker-alt"></i> Add marker</button>
      <div ref="marker-menu" v-show="editMarkerId" style="min-height:20px;min-width:100px;" @mouseover="showMarkerMenu = true" @mouseleave="showMarkerMenu = false">
        <div v-html="markerText" v-show="markerWithText">
        </div>
        <div
          v-show="(!previewMode && showMarkerMenu) || (editMarkerId && !previewMode && !markerWithText)"
          class="wf-absolute wf-w-full wf-h-full wf-max-w-full wf-max-h-full wf-top-0 wf-left-0 wf-flex wf-justify-center wf-items-center">
          <div class="wf-bg-blue-300 wf-inline-block wf-rounded-md">
            <button
              @click="openMarkerModal"
              class="wf-bg-transparent wf-text-white wf-p-2  wf-text-base wf-cursor-pointer wf-rounded-md wf-rounded-r-none hover:wf-bg-blue-500"
            ><i class="fas fa-pencil-alt"></i></button>
            <button
              @click="deleteMarker"
              class="wf-bg-transparent wf-text-white  wf-p-2 wf-text-base wf-cursor-pointer wf-rounded-md wf-rounded-l-none hover:wf-bg-blue-500"
            ><i class="fas fa-trash-alt"></i></button>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import WysiwygEditor from './WysiwygEditor'
  import EditorComponent from '../contracts/EditorComponent'
  import {UuidGenerator} from '../UuidGenerator'

  export default EditorComponent.extend({
    components: {WysiwygEditor},
    data() {
      return {
        showMarkerMenu: false,
        markerText: '',
        markerWithText: false,
        drawedMarkers: [],
        map: null,
        mapOptions: {},
        editMarkerId: null
      }
    },
    mounted() {
      this.initMap()
    },
    methods: {
      initMap() {
        this.mapOptions = {
          center: this.center,
          zoom: this.zoom,
          disableDefaultUI: true,
          mapTypeId: this.content.mapType,
          styles: this.content.mapStyle
        }

        if (this.map == null) {
          this.map = new google.maps.Map(this.$refs['google-maps'], this.mapOptions)
        }

        this.map.addListener('idle', () => {
          if (this.content.zoom != this.map.getZoom()) {
            this.zoom = this.map.getZoom()
          }

          if (this.content.lat != this.map.getCenter().lat() && this.content.lng != this.map.getCenter().lng()) {
            this.center = {
              lat: this.map.getCenter().lat(),
              lng: this.map.getCenter().lng()
            }
          }
        })

        this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(this.$refs['control-marker'])

        this.reDrawMarkers()
      },
      addMarker() {
          let newMarker = {
            position: this.map.getCenter(),
            id: `marker_${(new UuidGenerator).build()}`,
            textContent: 'Ipsum fugiat esse cillum ad eu officia consequat exercitation velit mollit elit culpa cupidatat.',
            withText: false,
            activationMode: 'click'
          }

          let markers = [...this.content.markers, newMarker]
          this.addToObject(this.module, {markers:markers}, 'content')

          this.drawMarker(newMarker, true)
      },
      deleteMarker() {
        if(! window.confirm('Are you sure you want to remove this marker?')) {
          return
        }
        let newMarkers = this.content.markers.filter(marker => marker.id != this.editMarkerId)
        this.addToObject(this.module, {markers: newMarkers}, 'content')

        this.drawedMarkers.map(drawedMarker => {
          if (drawedMarker.id == this.editMarkerId) {
            drawedMarker.setMap(null)
          }
        })
      },
      openMarkerModal() {
        this.$modal.show('markerModal', {
          module: this.module,
          element: this.element,
          markerId: this.editMarkerId,
          reDrawMarkers: this.reDrawMarkers
        })
      },
      updateMakerPosition(markerId, evt) {
        let newMarkers = Array.from(this.content.markers).map(marker => {
          if (markerId != marker.id) {
            return marker
          }
          let newPosition = {lat: evt.latLng.lat(), lng: evt.latLng.lng()}
          return {...marker, position: newPosition}
        })
        this.addToObject(this.module, {markers: newMarkers}, 'content')
      },
      drawMarker(marker, animate) {
        let drawedMarker = new google.maps.Marker({
          ...marker,
          draggable: this.previewMode ? false: true,
          animation: animate ? google.maps.Animation.DROP: null,
          map: this.map,
          icon: this.content.icon
        })

        let infoContent = this.previewMode ? marker.textContent : this.$refs['marker-menu']

        drawedMarker.infoWindow = new google.maps.InfoWindow({
          maxWidth: '50px',
          content: infoContent
        })

        let activationMode = this.previewMode ? marker.activationMode : 'click'

        drawedMarker.addListener(activationMode, () => {

          if (this.previewMode && !marker.withText) {
            return;
          }
          if (!this.previewMode) {
            this.drawedMarkers.forEach(marker => {
              marker.infoWindow.close()
            })
          }

          this.markerText = marker.textContent
          this.markerWithText = marker.withText
          this.editMarkerId = marker.id

          drawedMarker.infoWindow.open(this.map, drawedMarker)
        })

        if (activationMode == "mouseover") {
          drawedMarker.addListener('mouseout', () => {
            drawedMarker.infoWindow.close()
          })
        }


        google.maps.event.addListener(drawedMarker, 'dragend', (evt) => {
          this.updateMakerPosition(marker.id, evt)
        });


        this.drawedMarkers.push(drawedMarker)
      },
      reDrawMarkers() {
        this.drawedMarkers.forEach(marker => {
          marker.setMap(null)
        })
        this.drawedMarkers = []
        this.content.markers.forEach(marker => {
          this.drawMarker(marker)
        })
      }
    },
    watch: {
      previewMode(){
        this.reDrawMarkers()
      },
      content(value) {
        if (this.map) {

          this.map.setOptions({
            mapTypeId: value.mapType,
            styles: value.mapStyle,
            streetViewControl: value.streetViewControl,
            scaleControl: value.scaleControl,
            zoomControl: value.zoomControl
          })
        }
      },
      center(value) {
        if (this.map && !isNaN(value.lat) && !isNaN(value.lng)) {
          this.map.setCenter(value)
        }
      },
      zoom(value){
        if(this.map) {
          this.map.setZoom(value)
        }
      }
    },
    computed: {
      center: {
        get() {
          let center = {
            lat: parseFloat(this.$store.getters[`${this.module}/content`](this.element).lat) ?? 0,
            lng: parseFloat(this.$store.getters[`${this.module}/content`](this.element).lng) ?? 0
          }
          return center
        },
        set: _.debounce(function (value) {
          this.addToObject(this.module, {lat: value.lat}, 'content')
          this.addToObject(this.module, {lng: value.lng}, 'content')
        }, 10)
      },
      zoom: {
        get() {
          return this.$store.getters[`${this.module}/content`](this.element).zoom
        },
        set: _.debounce(function (value) {
          this.addToObject(this.module, {zoom: value}, 'content')
        }, 10)
      }
    }
  })
</script>

<style>
  div:contains-selector(.googleIW) {
    padding:1px;
  }
</style>